const Project1 = () => {
    return (
      <div>
        <h1>Project 3: StockOptimate</h1>
        <p> This project was React and Node.js with MSSQL as a DBMS. The purpose of this project was to create a standard Stock Management System. The data was also Visualized with the help of Power Bi </p>
      </div>
    );
  };
  
  export default Project1;
  